import { Accordion, NewSelect, Text, spacing } from '@retailer-platform/shared-components'
import { useDashMessages } from '../../../../intl/intl.hooks'
import {
  type PairedVersionNavFilterMode,
  useAdminControls,
} from '../../../../utils/contexts/admin-controls/AdminControlsContext'

const options: { label: string; value: PairedVersionNavFilterMode }[] = [
  { label: 'both', value: 'both' },
  { label: 'legacy', value: 'legacy' },
  { label: 'preview', value: 'preview' },
]

export const PairedVersionNavFilter = () => {
  const { pairedVersionNavFilter, setAdminControl } = useAdminControls()

  const i18n = useDashMessages({
    title: 'app.admin.controlPanel.setting.pairedVersionNavFilter.title',
    description: 'app.admin.controlPanel.setting.pairedVersionNavFilter.description',
    both: 'app.admin.controlPanel.setting.pairedVersionNavFilter.both',
    legacy: 'app.admin.controlPanel.setting.pairedVersionNavFilter.legacy',
    preview: 'app.admin.controlPanel.setting.pairedVersionNavFilter.preview',
  })

  const selectOptions = options.map(option => ({
    ...option,
    label: i18n[option.value],
  }))

  return (
    <Accordion showContentBackground={true} title={i18n.title}>
      <div css={{ display: 'flex', flexDirection: 'column', gap: spacing.X20 }}>
        <Text size="small">{i18n.description}</Text>

        <div css={{ padding: 10 }}>
          <NewSelect
            compact
            menuPlacement="top"
            menuPosition="fixed"
            value={pairedVersionNavFilter ?? 'both'}
            options={selectOptions}
            styles={{ menuPortal: baseStyles => ({ ...baseStyles, zIndex: 101 }) }}
            menuPortalTarget={document.body}
            onChange={value =>
              setAdminControl(
                'pairedVersionNavFilter',
                (value as PairedVersionNavFilterMode) ?? undefined
              )
            }
          />
        </div>
      </div>
    </Accordion>
  )
}
